import { Button, Collapse } from "@mantine/core";
import * as React from "react";
import RosterSupervisor, { IRosterSupervisorProps } from "./RosterSupervisor";

interface RosterSupervisorCollapseProps extends IRosterSupervisorProps {
  defaultIsOpen?: boolean;
  shiftId: string;
  sessionId: string;
  venueId: string;

  showHideAppointmentFromSheetButton: boolean
}

const RosterSupervisorCollapse: React.FunctionComponent<
  RosterSupervisorCollapseProps
> = ({ defaultIsOpen, ...other }) => {
  const [isOpen, toggle] = React.useState(
    defaultIsOpen !== undefined ? defaultIsOpen : false,
  );

  return (
    <div>
      <p style={{ float: "left", marginBottom: "0px" }}>
        <b>Supervisors</b>
      </p>
      <Button
        onClick={() => toggle(!isOpen)}
        style={{ float: "right", marginLeft: "100px" }}
        size="sm"
        color="blue"
        variant="outline"
      >
        {isOpen ? "Close" : "Open"}
      </Button>
      {isOpen && <br />}
      <Collapse in={isOpen}>
        <div style={{ marginTop: "16px" }}>
          <RosterSupervisor {...other} />
        </div>
      </Collapse>
    </div>
  );
};

export default RosterSupervisorCollapse;
